import { render, staticRenderFns } from "./Logpayment.vue?vue&type=template&id=667b924e&"
import script from "./Logpayment.vue?vue&type=script&lang=js&"
export * from "./Logpayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports